<template>
  <main class="individual-plan" style="background: #005d79;">
    <SimpleHeader route="/main">
      <template v-slot:title>
        <span>
         {{$ml.get('תוכנית התפתחות אישית')}}
        </span>
      </template>
      <span slot="additional">
        <sidebar-toggler />
        <router-link :to="'/'" class="home-anchor" style="color: white;">
          <svg
                    width="22"
                    height="20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="position:absolute; top: 4px; right: 24px;"
                  >
                    <path
                      d="M10.3312 0.926701L10.2632 0.863573L10.1951 0.926701L0.931976 9.52313L0.85877 9.59106L0.926614 9.66436L1.78441 10.591L1.85245 10.6645L1.92585 10.5964L2.59093 9.9786V17V17.1H2.69093H9.00112H9.10112V17V10.7907H11.4252V17V17.1H11.5252H17.8354H17.9354V17V9.9786L18.6005 10.5964L18.6739 10.6645L18.7419 10.591L19.5997 9.66436L19.6675 9.59106L19.5943 9.52313L10.3312 0.926701ZM16.4733 8.6246V15.6381H12.8872V9.42883V9.32883H12.7872H7.73908H7.63908V9.42883V15.6381H4.05297V8.6246L10.2632 2.85187L16.4733 8.6246Z"
                      fill="white"
                      stroke="white"
                      stroke-width="0.2"
                    />
                  </svg>
        </router-link>
      </span>
    </SimpleHeader>
    <app-loading class="sm-cont" style="background: #fff;">
      <template>
        <div class="individual-plan-wrapper">
          <div class="header">
            <div class="title">{{$ml.get('תוכנית משחקים אישית')}}</div>
            <div class="header-info">
              <div class="info-element">
                <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0V14H4.30769V12.9231H1.07692V1.07692H6.46154V4.30769H9.69231V7.53846H10.7692V3.54627L7.22296 0H0ZM7.53846 1.83834L8.93089 3.23077H7.53846V1.83834ZM9.69231 8.61539V14H10.7692V8.61539H9.69231ZM7.53846 10.2308V14H8.61539V10.2308H7.53846ZM5.38462 11.8462V14H6.46154V11.8462H5.38462Z" fill="#00465B"/>
                </svg>
                <span>{{$ml.get('דו“ח פעילות התלמיד')}}</span>
              </div>

              <div class="info-element">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.29948 0C2.73665 0 2.31738 0.187988 2.06901 0.483073C1.82064 0.778158 1.75 1.14502 1.75 1.45833C1.75 2.20345 2.15332 2.80843 2.70703 3.19922C2.87793 3.31999 3.05908 3.41569 3.25391 3.5H0V6.70833H0.583333V14H13.4167V6.70833H14V3.5H10.7461C10.9409 3.41569 11.1221 3.31999 11.293 3.19922C11.8467 2.80843 12.25 2.20345 12.25 1.45833C12.25 1.14502 12.1794 0.778158 11.931 0.483073C11.6826 0.187988 11.2633 0 10.7005 0C10.1183 0 9.64779 0.246094 9.29688 0.583333C8.94596 0.920573 8.69417 1.34554 8.45833 1.75C8.22249 2.15446 8.00033 2.54297 7.76562 2.80729C7.53092 3.07161 7.31673 3.20833 7 3.20833C6.68327 3.20833 6.46908 3.07161 6.23438 2.80729C5.99967 2.54297 5.77751 2.15446 5.54167 1.75C5.30583 1.34554 5.05404 0.920573 4.70312 0.583333C4.35221 0.246094 3.88167 0 3.29948 0ZM3.29948 0.583333C3.72673 0.583333 4.01839 0.738281 4.29297 1.0026C4.56755 1.26693 4.80908 1.64404 5.04036 2.04167C5.27165 2.43929 5.49837 2.85286 5.79688 3.1901C5.80257 3.19694 5.80941 3.2015 5.8151 3.20833H4.66667C4.07878 3.20833 3.47152 3.03288 3.03516 2.72526C2.5988 2.41764 2.33333 2.00179 2.33333 1.45833C2.33333 1.23844 2.38574 1.02083 2.51562 0.865885C2.64551 0.710938 2.85856 0.583333 3.29948 0.583333ZM10.7005 0.583333C11.1414 0.583333 11.3545 0.710938 11.4844 0.865885C11.6143 1.02083 11.6667 1.23844 11.6667 1.45833C11.6667 2.00179 11.4012 2.41764 10.9648 2.72526C10.5285 3.03288 9.92122 3.20833 9.33333 3.20833H8.1849C8.19059 3.2015 8.19743 3.19694 8.20312 3.1901C8.50163 2.85286 8.72835 2.43929 8.95964 2.04167C9.19092 1.64404 9.43245 1.26693 9.70703 1.0026C9.98161 0.738281 10.2733 0.583333 10.7005 0.583333ZM0.583333 4.08333H5.25V6.125H0.583333V4.08333ZM5.83333 4.08333H8.16667V6.36198C8.16667 6.37109 8.16667 6.38021 8.16667 6.38932C8.16667 6.39844 8.16667 6.40755 8.16667 6.41667C8.16439 6.43831 8.16439 6.45882 8.16667 6.48047V13.4167H5.83333V6.47135C5.83561 6.45312 5.83561 6.4349 5.83333 6.41667C5.83447 6.40413 5.83447 6.39274 5.83333 6.38021C5.83333 6.37109 5.83333 6.36198 5.83333 6.35286V4.08333ZM8.75 4.08333H13.4167V6.125H8.75V4.08333ZM1.16667 6.70833H5.25V13.4167H1.16667V6.70833ZM8.75 6.70833H12.8333V13.4167H8.75V6.70833Z" fill="#00465B"/>
                </svg>

                <span>{{$ml.get('בחירת מיומנויות וכישורי חיים')}}</span>
              </div>
            </div>
          </div>
          <div class="list">
            <PlanItem
              :plan="plan"
              :key="i*2"
              :student="student"
              v-for="(student,i) in students"
            />
          </div>
        </div>
      </template>
    </app-loading>
  </main>
</template>

<script>

import SimpleHeader from "@/components/SimpleHeader.vue";
import SidebarToggler from "@/components/SidebarToggler.vue";
import TeacherProfileRadio from "@/components/teacher/TeacherProfileRadio";
import PlanItem from "@/components/teacher/PlanItem";
import {TeacherAPI} from "@/api";

export default {
  data() {
    return {
      index: 0,
      popup_showed: false,
      choice: '',
      radio: '',
      students: [],
      loading: {
        next: false,
        sync: false
      },
      plan:{
        title: 'הותאם אישית ב',
        name: 'גילה צילה ',
        src: '',
        stonks: true,
        present: true,
        data: '11.12.19',
      },
      plap:{
        title: 'הותאם אישית ב',
        name: 'גילה צילה ',
        src: '',
        stonks: false,
        present: true,
        data: '11.12.19',
      },
    };
  },
  components: {

    // GiftLine,
    SimpleHeader,
    SidebarToggler,
    TeacherProfileRadio,
    PlanItem,
  },
  created() {
    window.fbq("track", "תוכנית משחקים אישית");
    TeacherAPI.activities().then(res=>{
      this.students = res.data;
    })
  },
  methods: {
    goRoute(){
      this.$router.push('https://docs.google.com/uc?export=download&id=1ET5Nx-SHaHCCORdSDhIWbqFGIU3R3KWL');
    }
  },

};
</script>
<style scoped lang="scss">
.individual-plan {
  background: white;
  display: flex;
  flex-direction: column;

  .app-loading {
    flex-grow: 1;
    min-height: 450px;


    .individual-plan-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      .title{
        margin: 20px 0 10px 0;
        font-style: normal;
        font-weight: normal;
        font-size: 21px;
        text-align: center;
        color: #00465B;
      }
      .header{
        .header-info{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .info-element{
            margin: 12px 0;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            text-align: right;
            color: #00465B;
            display: flex;
            align-items: flex-start;
            svg{
              margin: 3px 5px 0 5px;
            }
            .element-d{
              .row{
                display: flex;
                align-items: center;
              }
            }
            .row-element{
              margin: 0 5px;
              padding: 0 12px;
              position: relative;
            }
            .green{
              &:after{
                position: absolute;
                width: 8px;
                height: 8px;
                content: '';
                border-radius: 50%;
                background: #8CC63F;
                top: 7px;
                right: 0;
              }
            }
            .blue{
              &:after{
                position: absolute;
                width: 8px;
                height: 8px;
                content: '';
                border-radius: 50%;
                background: #00465B;
                top: 7px;
                right: 0;
              }
            }
            .gray{
              &:after{
                position: absolute;
                width: 8px;
                height: 8px;
                content: '';
                border-radius: 50%;
                background: #C4C4C4;
                top: 7px;
                right: -5px;
              }
            }
          }
        }
      }
      .list{
        margin-top: 50px;
        width: 100%;
        padding: 0 10px;
      }
    }
  }
}

</style>